import { useEffect, useState } from 'react';
import { ensureCanvasForOutline, hasCanvas } from '../../utils/canvasSchema';

/**
 * PPT 개요에 캔버스가 없으면 서버에서 채워 상세·발표가 같은 쪽을 쓰게 한다.
 */
export default function useHydratedPptOutline(outline, key) {
  const [hydratedOutline, setHydratedOutline] = useState(null);

  useEffect(() => {
    let cancelled = false;
    const slides = outline?.slides;
    if (!Array.isArray(slides) || slides.length === 0) {
      setHydratedOutline(null);
      return () => { cancelled = true; };
    }
    const needsCanvas = slides.some((slide) => !hasCanvas(slide));
    if (!needsCanvas) {
      setHydratedOutline(null);
      return () => { cancelled = true; };
    }
    ensureCanvasForOutline(outline, { silent: true })
      .then((next) => {
        if (cancelled) return;
        const hydrated = Array.isArray(next?.slides) && next.slides.some((slide) => hasCanvas(slide));
        setHydratedOutline(hydrated ? next : null);
      })
      .catch(() => {
        if (!cancelled) setHydratedOutline(null);
      });
    return () => { cancelled = true; };
  }, [outline, key]);

  return hydratedOutline || outline;
}
